import ConfirmModal from './ConfirmModal'
import ConfirmUpdateModal from './ConfirmUpdateModal'
import ForgotPassowrdModal from './ForgotPassowrdModal'
import ImportModal from './ImportModal'
import LiveCCTVModal from './LiveCCTVModal'
import ProofingConfirmModal from './ProofingConfirmModal'

interface IModal {
  ConfirmUpdateModal: typeof ConfirmUpdateModal
  ConfirmModal: typeof ConfirmModal
  ForgotPassowrdModal: typeof ForgotPassowrdModal
  LiveCCTVModal: typeof LiveCCTVModal
  ImportModal: typeof ImportModal
  ProofingConfirmModal: typeof ProofingConfirmModal
}

const OptionsModal: IModal = {
  ConfirmModal,
  ConfirmUpdateModal,
  ForgotPassowrdModal,
  LiveCCTVModal,
  ImportModal,
  ProofingConfirmModal,
}

export { ModalBody, ModalFooter, styleMapHeight } from './customize-style'
export default OptionsModal
